import React, { useEffect, useRef, useState } from 'react';

import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import { useKeyboard } from '$hooks/events';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

const FilterDrawer = ({
    isNavOpen,
    children,
    handleClose,
}) => {
    const dialogRef = useRef();
    const scrollElementRef = useRef();

    const [animationOut, setAnimationOut] = useState(false);

    useKeyboard({
        'Escape': (event) => {
            // Prevent dialog's default behaviour
            event.preventDefault();

            if (isNavOpen) {
                handleClose();
            }
        }
    }, [isNavOpen]);

    useEffect(() => {
        // use close/showModal methods to trigger browser's toplayer/inert mode
        const dialogNode = dialogRef.current;
        const scrollElementNode = scrollElementRef.current;
        if (isNavOpen) {
            if (dialogNode && !dialogNode.open && scrollElementNode) {
                disableBodyScroll(scrollElementNode);
                dialogNode.showModal?.();
            }
        } else {
            if (dialogNode && dialogNode.open && scrollElementNode) {

                if (window.innerWidth > 767) {
                    // Play outro animation for sm and above
                    setAnimationOut(true);
                    setTimeout(() => {
                        dialogNode.close?.();
                        setAnimationOut(false);
                    }, 300);
                } else {
                    dialogNode.close?.();
                }
            }
            enableBodyScroll(scrollElementNode);
        }
    }, [isNavOpen]);

    return (
        <dialog
            className={'dialog-reset backdrop:bg-black/40'}
            onClick={handleClose}
            ref={dialogRef}>
            <div
                className={`no-scrollbar fixed sm:top-0 bottom-0 left-0 h-[80vh] sm:h-dvh filter-dialog ${animationOut ? 'filter-dialog__outro' : ''} bg-white `}
                /* `stopPropagation()` to not close dialog when dialog is clicked */
                onClick={(e) => e.stopPropagation()}
                ref={scrollElementRef}>
                <div className='relative overflow-y-scroll h-full'>
                    {children}
                </div>
            </div>
        </dialog>
    );
};


/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default FilterDrawer;
